import { useState } from "react";
import Footer from "./components/Footer";
import Header from "./components/Header";
import NavBar from "./components/NavBar";
import Login from "./pages/login";
import { ROUTER } from "./router";
import store from './store';
import jwtDecode from 'jwt-decode';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.scss";
import { getCurrentUser } from "./features/api/authApi";
import { clearUser, setUser } from "./features/slice/authSlice";
import 'react-toastify/dist/ReactToastify.css';

if (localStorage.jwtToken) {
  const decoded = jwtDecode(localStorage.jwtToken);
  console.log(decoded);
  const currentTime = Date.now() / 1000;
  if (decoded.exp < currentTime) {
    store.dispatch(clearUser());
  } else {
    const userData = await getCurrentUser(decoded);
    if (userData?.status) {
      store.dispatch(setUser(userData?.data));
    }
  }
}

const AuthChecker = ({ children }) => {
  if (localStorage.jwtToken) {
    return children;
  } else {
    return <Navigate to="/login" replace />;
  }
};

function App() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path='/login' element={<Login />}></Route>
          {ROUTER.map((route, index) => {
            return (
              <Route
                key={index}
                exact
                path={route.url}
                element={
                  route.url !== "/" ? (
                    <AuthChecker>
                      <NavBar sx={{ width: '100%', overflow: 'hidden', position: 'relative', '& .ps__rail-y': { zIndex: 5 } }} mobileOpen={mobileOpen} handleDrawerToggle={handleDrawerToggle} />
                      <hr />
                      <div className="outer-container">
                        <Header mobileOpen={mobileOpen} handleDrawerToggle={handleDrawerToggle} />
                        <route.component />
                        <Footer />
                      </div>
                    </AuthChecker>
                  ) : (
                    <AuthChecker>
                      <NavBar mobileOpen={mobileOpen} handleDrawerToggle={handleDrawerToggle} />
                      <hr />
                      <div className="outer-container">
                        <Header mobileOpen={mobileOpen} handleDrawerToggle={handleDrawerToggle} />
                        <route.component />
                      </div>
                    </AuthChecker>
                  )
                }
              />
            );
          })}
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
